import { axiosInstance } from "utils";

interface MeltanoConnectionPayload {
  connectionType: number;
  clientId: string;
  // generic metadata for Meltano connections
  config: {[key: string]: string};
}

export const createMeltanoConnection = (payload: MeltanoConnectionPayload) =>
  axiosInstance.post("/connection/meltano", payload); 